import gql from "graphql-tag";

export const GET_MEDICO_BY_COGNITO_ID = gql`
  query findMedicoBy($cognito_id: String) {
    findMedicoBy(cognito_id: $cognito_id) {
      id
      nombre
      primer_apellido
      segundo_apellido
      auxiliares {
        id
        nombre
        primer_apellido
        segundo_apellido
      }
    }
  }
`;

export const GET_ALL_ESPECIALIDADES = gql`
  query findAllEspecialidades {
    findAllEspecialidades {
      id
      nombre
      descripcion
    }
  }
`;

export const GET_ALL_HOSPITALES = gql`
  query findAllHospitales {
    findAllHospitales {
      id
      nombre
      descripcion
    }
  }
`;
